module.exports = __webpack_public_path__ + "img/vertical_3_3_8011.af5d338b.png";